import React, { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as BSIcons from "react-icons/bs";
import * as IMIcons from "react-icons/im";
import * as RiIcons from "react-icons/ri";
import * as GoIcons from "react-icons/go";
import * as MdIcons from "react-icons/md";
import * as TbIcons from "react-icons/tb";
import * as HiIcons from "react-icons/hi";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { IconContext } from "react-icons";
import logo from "../assets/logo.png";
import AuthService from "../services/auth.service";
function Navbar() {
  const [sidebar, setSidebar] = useState(false);
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [litigation, setLitigation] = useState(false);
  const [investigation, setInvestigation] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);
  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      console.log(user.id);
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
      var access = user.access;
      setLitigation(user.access ? access.includes("Litigation") : false);
      setInvestigation(access ? access.includes("Investigations") : false);
    }
  }, []);

  const InvestigationData = [
    {
      title: "Requests",
      path: "/requests",
      icon: <AiIcons.AiOutlineFileText />,
      cName: "nav-text",
    },

    {
      title: "Reports",
      path: "/reports",
      icon: <TbIcons.TbReportAnalytics />,
      cName: "nav-text",
    },
    {
      title: "Deadline",
      path: "/deadline",
      icon: <MdIcons.MdOutlineSchedule />,
      cName: "nav-text",
    },
    {
      title: "Summary",
      path: "/summary",
      icon: <GoIcons.GoGraph />,
      cName: "nav-text",
    },
    {
      title: "Agencies",
      path: "/agencies",
      icon: <RiIcons.RiGovernmentFill />,
      cName: "nav-text",
    },
    {
      title: "Agency Contacts",
      path: "/contacts",
      icon: <MdIcons.MdContactPhone />,
      cName: "nav-text",
    },
  ];
  const SidebarData = [
    {
      title: "Home",
      path: "/",
      icon: <AiIcons.AiFillHome />,
      cName: "nav-text",
    },
    {
      title: "Lawsuits",
      path: "/cases",
      icon: <IMIcons.ImHammer2 />, //IoIosPaper -> ImHammer2
      cName: "nav-text",
    },
    /*{
      title: 'Profile',
      path: '/profile',
      icon: <FaIcons.FaCartPlus />,
      cName: 'nav-text'
    },*/
    {
      title: "Calendar",
      path: "/calendar",
      icon: <BSIcons.BsFillCalendar2DateFill />,
      cName: "nav-text",
    },
    {
      title: "AUSA Firms",
      path: "/firms",
      icon: <GoIcons.GoLaw />,
      cName: "nav-text",
    },
    {
      title: "AUSA Attorneys",
      path: "/attorneys",
      icon: <IoIcons.IoMdPeople />,
      cName: "nav-text",
    },
    {
      title: "Mark-Up",
      path: "/markup",
      icon: <RiIcons.RiMarkupFill />,
      cName: "nav-text",
    },
    /*,
    {
      title: '',
      path: '',
      icon: <img className="photo" src={logo} alt="Logo" />,
      cName: 'nav-image'
    }*/
  ];
  // document.addEventListener("click", () => {
  //   if (Navbar.classList.contains("nav-menu")) {
  //     Navbar.classList.remove("nav-menu")
  //      }
  //   }, true);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <div className="navbar">
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>
        </div>
        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-menu-items" onClick={showSidebar}>
            <li className="navbar-toggle">
              <Link to="#" className="menu-bars">
                <AiIcons.AiOutlineClose />
              </Link>
            </li>

            {litigation &&
              SidebarData.map((item, index) => {
                return (
                  <li key={index} className={item.cName}>
                    <Link to={item.path}>
                      {item.icon}
                      <span>{item.title}</span>
                    </Link>
                  </li>
                );
              })}
            {investigation &&
              InvestigationData.map((item, index) => {
                return (
                  <li key={index} className={item.cName}>
                    <Link to={item.path}>
                      {item.icon}
                      <span>{item.title}</span>
                    </Link>
                  </li>
                );
              })}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
